<div
    *ngIf="tableLoad"
    style="
        display: block !important;
        z-index: 1000000;
        width: 250px;
        height: 250px;
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    "
>
    <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
    <div
        class="lds-circle"
        style="
            margin: auto;
            position: absolute;
            width: 150px;
            height: auto;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        "
    >
        <div></div>
    </div>
</div>
<div class="row d-flex justify-content-center modalWrapper">
    <ejs-dialog
        #confirmationDelete
        [buttons]="buttonsDelete"
        [content]="'Opravdu chcete de-autorizovat označeného uživatele?'"
        [header]="'De-autorizovat uživatele'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        width="250px"
    ></ejs-dialog>
    <ejs-dialog
        #confirmationCancel
        [buttons]="buttonsCancel"
        [header]="'Nelze provést akci'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        width="250px"
    ></ejs-dialog>
    <ejs-dialog
        #confirmationAuthorized
        [buttons]="buttonsAuthorized"
        [content]="'Opravdu chcete re-autorizovat tohoto uživatele?'"
        [header]="'RE-Autorizovat uživatele'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        width="400px"
    ></ejs-dialog>
    <app-user-form
        (userFormDialogState)="
            renderUserFormDialog = $event;
            isCreate = $event;
            isUpdate = $event;
            isCopy = $event;
            gridUsers?.clearRowSelection();
            disableToolBarBtn()
        "
        [isCopy]="isCopy"
        [isCreate]="isCreate"
        [isUpdate]="isUpdate"
        [isVisible]="renderUserFormDialog"
        [user]="
            clickedRow && clickedRow[0] && (isUpdate || isCopy)
                ? clickedRow[0]
                : null
        "
    ></app-user-form>
</div>
<ejs-toolbar id="filterToolbar" overflowMode="Scrollable" scrollStep="500">
    <e-items>
        <e-item
            [cssClass]="'statusFilter'"
            tooltipText="Přednastavené hledání"
            type="input"
        >
            <ng-template #template>
                <ejs-dropdownlist
                    #viewFilter
                    (change)="onStatusFilterChange($event)"
                    [dataSource]="categoryFilterData"
                    [width]="500"
                    placeholder="Vyberte přednastavený pohled..."
                ></ejs-dropdownlist>
            </ng-template>
        </e-item>
        <e-item type="Separator"></e-item>
        <e-item
            [cssClass]="'fulltextFilter'"
            tooltipText="Text pro vyhledávání"
            type="input"
        >
            <ng-template #template>
                <ejs-textbox
                    #searchtext
                    [width]="500"
                    class="mr-2"
                    placeholder="Vyhledat..."
                ></ejs-textbox>
                <button
                    (click)="search()"
                    class="e-btn e-info btn-p-zero e-small"
                >
                    <i class="fa-light fa-lg fa-search mr-1"></i
                    ><span class="d-none d-lg-inline">vyhledat</span>
                </button>
                <button
                    (click)="cancelBtnClick()"
                    class="e-btn e-danger btn-p-zero e-small"
                >
                    <i class="fa-light fa-lg fa-times"></i>
                </button>
            </ng-template>
        </e-item>
    </e-items>
</ejs-toolbar>
<div class="control-section">
    <div class="scroll_wrapper1" id="scroll_wrapper1_users">
        <div class="scroll_div" id="scroll_div_users"></div>
    </div>
    <div class="scroll_wrapper2" id="scroll_wrapper2_users">
        <div class="grid_parent" id="grid_parent_users">
            <ejs-grid
                #usersGrid
                (actionBegin)="actionBegin($event)"
                (actionComplete)="actionComplete($event)"
                (created)="onCreated()"
                (dataBound)="onDataBound()"
                (load)="onLoad()"
                (loadeddata)="setInitialGridFiltering()"
                (rowDataBound)="rowDataBound($event)"
                (rowDeselected)="rowSelected()"
                (rowSelected)="rowSelected()"
                (toolbarClick)="toolbarClick($event)"
                [allowExcelExport]="true"
                [allowFiltering]="true"
                [allowMultiSorting]="true"
                [allowPdfExport]="false"
                [allowSelection]="true"
                [allowSorting]="true"
                [dataSource]="data"
                [editSettings]="editSettings"
                [enableHover]="false"
                [enablePersistence]="false"
                [enableVirtualization]="true"
                [filterSettings]="filterSettings"
                [groupSettings]="groupOptions"
                [pageSettings]="pageOptions"
                [selectionSettings]="selectionSettings"
                [toolbar]="toolbar"
                allowGrouping="true"
                allowReordering="true"
                allowResizing="true"
                allowTextWrap="true"
                height="100%"
                id="usersGrid"
                locale="cs"
                rowHeight="38"
                showColumnMenu="true"
                width="100%"
            >
                <e-columns>
                    <e-column
                        [allowEditing]="false"
                        [allowFiltering]="false"
                        [allowReordering]="false"
                        [allowResizing]="false"
                        [allowSorting]="false"
                        [autoFit]="true"
                        type="checkbox"
                    ></e-column>
                    <e-column
                        [allowFiltering]="false"
                        [allowReordering]="true"
                        [allowResizing]="false"
                        [autoFit]="true"
                        [isPrimaryKey]="true"
                        [visible]="true"
                        field="id"
                        headerText="ID"
                    >
                        <ng-template #template let-data>
                            <a [routerLink]="['/users/detail/', data.id]">
                                {{ data.id }}
                            </a>
                        </ng-template>
                    </e-column>
                    <e-column
                        [allowEditing]="false"
                        [allowFiltering]="true"
                        [allowReordering]="false"
                        [allowResizing]="false"
                        [autoFit]="true"
                        [visible]="false"
                        field="created_by"
                        headerText="Creator ID"
                    ></e-column>
                    <e-column
                        [allowEditing]="false"
                        [allowFiltering]="true"
                        [allowReordering]="false"
                        [allowResizing]="false"
                        [autoFit]="true"
                        [visible]="false"
                        field="boss_id"
                        headerText="Boss ID"
                    ></e-column>
                    <e-column
                        [allowEditing]="false"
                        [allowFiltering]="true"
                        [allowReordering]="false"
                        [allowResizing]="false"
                        [autoFit]="true"
                        [visible]="false"
                        field="employer_id"
                        headerText="Employer ID"
                    ></e-column>
                    <e-column
                        [allowEditing]="false"
                        [allowFiltering]="true"
                        [allowReordering]="false"
                        [allowResizing]="false"
                        [autoFit]="true"
                        [visible]="false"
                        field="hotliner_id"
                        headerText="Hotliner ID"
                    ></e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="user_str"
                        headerText="Uživatel"
                    >
                        <ng-template #template let-data>
                            <div>
                                <img
                                    *ngIf="data.user_img"
                                    alt="profilový obrázek"
                                    class="img-fluid rounded-circle avatar-xs mr-1"
                                    src="assets/img{{ data.user_img }}"
                                />
                                <span>{{ data.user_str }}</span>
                            </div>
                        </ng-template>
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="boss_str"
                        headerText="Nadřízený"
                    >
                        <ng-template #template let-data>
                            <div *ngIf="data.boss_id">
                                <img
                                    *ngIf="data.boss_img"
                                    alt="profilový obrázek"
                                    class="img-fluid rounded-circle avatar-xs mr-1"
                                    src="assets/img{{ data.boss_img }}"
                                />
                                <span>{{ data.boss_str }}</span>
                            </div>
                            <div *ngIf="!data.boss_id">
                                <strong>bez nadřízeného</strong>
                            </div>
                        </ng-template>
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="employer_str"
                        headerText="Zaměstnavatel"
                    >
                        <ng-template #template let-data>
                            <div>
                                <span *ngIf="data.employer_id">{{
                                    data.employer_str
                                }}</span>
                                <span *ngIf="!data.employer_id"
                                    >bez zaměstnavatele</span
                                >
                            </div>
                        </ng-template>
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="authorized"
                        headerText="Stav uživatele"
                    >
                        <ng-template #template let-data>
                            <span
                                *ngIf="data.authorized"
                                class="e-badge e-badge-success"
                                >autorizovaný</span
                            >
                            <span
                                *ngIf="!data.authorized"
                                class="e-badge e-badge-danger"
                                >deautorizovaný</span
                            >
                        </ng-template>
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="emailverify"
                        headerText="Stav emailové adresy"
                    >
                        <ng-template #template let-data>
                            <span
                                *ngIf="data.emailverify"
                                class="e-badge e-badge-success"
                                >email ověřen</span
                            >
                            <span
                                *ngIf="!data.emailverify"
                                class="e-badge e-badge-danger"
                                >email není ověřen</span
                            >
                        </ng-template>
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [edit]="{ params: { decimals: 1, step: 0.5 } }"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        editType="numericedit"
                        field="vacation"
                        format="N1"
                        headerText="Zbývající dovolená"
                        textAlign="Right"
                    >
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [edit]="{ params: { decimals: 1, step: 0.5 } }"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        editType="numericedit"
                        field="sickdays"
                        format="N1"
                        headerText="Zbývající sickdays"
                        textAlign="Right"
                    >
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="position"
                        headerText="Pozice"
                    ></e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="assignations"
                        headerText="Zapojení"
                    >
                        <ng-template #template let-data>
                            <div [innerHTML]="data.assignations"></div>
                        </ng-template>
                    </e-column>
                    <e-column
                        [allowFiltering]="false"
                        [allowReordering]="true"
                        [allowResizing]="true"
                        [autoFit]="true"
                        [isPrimaryKey]="true"
                        [visible]="true"
                        field="telnumber"
                        headerText="Telefon"
                    >
                        <ng-template #template let-data>
                            <a href="tel:+420{{ data.telnumber }}">{{
                                data.telnumber
                            }}</a>
                        </ng-template>
                    </e-column>
                    <e-column
                        [allowFiltering]="true"
                        [allowReordering]="true"
                        [allowResizing]="true"
                        [autoFit]="true"
                        [visible]="true"
                        field="workemail"
                        headerText="E-mail"
                    >
                        <ng-template #template let-data>
                            <a href="mailto:{{ data.workemail }}">{{
                                data.workemail
                            }}</a>
                        </ng-template>
                    </e-column>
                    <e-column
                        [autoFit]="true"
                        [filter]="filterSettings"
                        clipMode="EllipsisWithTooltip"
                        field="creator_str"
                        headerText="Vytvořil"
                    >
                        <ng-template #template let-data>
                            <div>
                                <img
                                    *ngIf="data.creator_img"
                                    alt="profilový obrázek"
                                    class="img-fluid rounded-circle avatar-xs mr-1"
                                    src="assets/img{{ data.creator_img }}"
                                />
                                <span>{{ data.creator_str }}</span>
                            </div>
                        </ng-template>
                    </e-column>
                    <e-column
                        [allowEditing]="false"
                        [autoFit]="true"
                        [filter]="filterDate"
                        [format]="dateFormat"
                        clipMode="EllipsisWithTooltip"
                        editType="datepickeredit"
                        field="created_date"
                        headerText="Vytvořeno"
                        textAlign="Right"
                        type="date"
                    ></e-column>
                    <e-column
                        [allowEditing]="false"
                        [autoFit]="true"
                        [filter]="filterDate"
                        [format]="dateFormat"
                        clipMode="EllipsisWithTooltip"
                        editType="datepickeredit"
                        field="updated_date"
                        headerText="Naposledy upraveno"
                        textAlign="Right"
                        type="date"
                    ></e-column>
                    <e-column
                        [allowEditing]="false"
                        [autoFit]="true"
                        [filter]="filterDate"
                        [format]="dateFormat"
                        clipMode="EllipsisWithTooltip"
                        editType="datepickeredit"
                        field="deleted_date"
                        headerText="Smazáno"
                        textAlign="Right"
                        type="date"
                    ></e-column>
                </e-columns>
                <e-aggregates>
                    <e-aggregate>
                        <e-columns>
                            <e-column [format]="'N'" field="id" type="Count">
                                <ng-template #footerTemplate let-data>
                                    Celkem řádků: {{ data.Count }}
                                </ng-template>
                            </e-column>
                            <e-column
                                [format]="'N'"
                                field="vacation"
                                type="Sum"
                            >
                                <ng-template #footerTemplate let-data>
                                    Celkem dovolené: {{ data.Sum }}
                                </ng-template>
                            </e-column>
                            <e-column
                                [format]="'N'"
                                field="sickdays"
                                type="Sum"
                            >
                                <ng-template #footerTemplate let-data>
                                    Celkem sickdays: {{ data.Sum }}
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </e-aggregate>
                    <e-aggregate>
                        <e-columns>
                            <e-column
                                [format]="'N'"
                                field="vacation"
                                type="Average"
                            >
                                <ng-template #footerTemplate let-data>
                                    Průměr dovolené: {{ data.Average }}
                                </ng-template>
                            </e-column>
                            <e-column
                                [format]="'N'"
                                field="sickdays"
                                type="Average"
                            >
                                <ng-template #footerTemplate let-data>
                                    Průměr sickdays: {{ data.Average }}
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </e-aggregate>
                    <e-aggregate>
                        <e-columns>
                            <e-column
                                [format]="'N'"
                                field="vacation"
                                type="Max"
                            >
                                <ng-template #footerTemplate let-data>
                                    Max dovolené: {{ data.Max }}
                                </ng-template>
                            </e-column>
                            <e-column
                                [format]="'N'"
                                field="sickdays"
                                type="Max"
                            >
                                <ng-template #footerTemplate let-data>
                                    Max sickdays: {{ data.Max }}
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </e-aggregate>
                </e-aggregates>
            </ejs-grid>
        </div>
    </div>
</div>
